import React from "react";
import { View } from "@/components/ui";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu/";
import { IconButton } from "@/components/ui/icon-button";

import { type IconNames } from "../icons/icon-map";
import { Typography } from "../typography";

export interface ActionItem {
  label: string;
  render?: (label: string) => React.ReactNode;
  onClick: () => void;
}

export const OtherActionsDropdown = ({
  icon = "dotsThreeOutline",
  actions,
  size = "sm",
}: {
  icon?: IconNames;
  size?: "xs" | "sm" | "md" | "lg" | "xl";
  actions: ActionItem[];
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <IconButton iconName={icon} color="CTA2" variant="secondary" rounded="full" size={size} />
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        {actions.map((action, index) => (
          <React.Fragment key={`${action.label}-${index}`}>
            {index !== 0 && <DropdownMenuSeparator />}
            {/* asChild, so the item's own press (which closes the menu) runs
                with the action; on iOS and Android the View took the press */}
            <DropdownMenuItem className="cursor-pointer" asChild>
              <View onClick={action.onClick}>
                {action.render ? (
                  action.render(action.label)
                ) : (
                  <Typography variant="body-sm">{action.label}</Typography>
                )}
              </View>
            </DropdownMenuItem>
          </React.Fragment>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
